export const INDICATOR = 1
export const FUNDAMENTAL = 2
export const ALTERNATIVE = 3
export const INDICATOR_TRIGGER = '@'
export const FUNDAMENTAL_TRIGGER = '#'
export const ALTERNATIVE_TRIGGER = '&'

export const INDICATOR_REG_EX = /^@/
export const FUNDAMENTAL_REG_EX = /^#/
export const ALTERNATIVE_REG_EX = /^&/


export const triggerByType = (type) => {
  switch (type) {
  case INDICATOR:
    return INDICATOR_TRIGGER
  case FUNDAMENTAL:
    return FUNDAMENTAL_TRIGGER
  case ALTERNATIVE:
    return ALTERNATIVE_TRIGGER
  }
}

export const regExByType = (type) => {
  switch (type) {
  case INDICATOR:
    return INDICATOR_REG_EX
  case FUNDAMENTAL:
    return FUNDAMENTAL_REG_EX
  case ALTERNATIVE:
    return ALTERNATIVE_REG_EX
  }
}
